import React from 'react';
import { IHeaderParams } from 'ag-grid-community';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faAnglesUpDown } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

export interface CustomHeaderProps extends IHeaderParams {
  onHeaderClick?: () => void;
  showArrow?: boolean;
  arrowDirection?: 'up' | 'down' | 'neutral';
}

/**
 * Componente de header personalizado para AG Grid
 * Muestra el nombre del header con un botón que tiene una flecha
 */
export const CustomHeader: React.FC<CustomHeaderProps> = ({
  displayName,
  onHeaderClick,
  showArrow = true,
  arrowDirection = 'neutral',
}) => {
  const { t } = useTranslation('ui');
  const handleClick = () => {
    if (onHeaderClick) {
      onHeaderClick();
    }
  };

  return (
    <div className="flex items-center gap-2 w-full">
      <span className="text-title">{displayName}</span>
      {showArrow && (
        <button
          type="button"
          onClick={handleClick}
          className="flex items-center justify-center w-5 h-5 rounded hover:bg-hover-press transition-colors"
          title={t('agGridTable.sortTooltip')}
        >
          <FontAwesomeIcon
            icon={
              arrowDirection === 'up' 
                ? faChevronUp 
                : arrowDirection === 'down' 
                ? faChevronDown 
                : faAnglesUpDown
            }
            className="text-xs text-icons"
          />
        </button>
      )}
    </div>
  );
};

